module.exports = "<main class=\"kl-main {class}\" r-class=\"{ { 'is-master': isMaster  } }\" r-style={{'left': left}}>\n    {#inc this.$body}\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLLayout/KLMain/index.html
// module id = 567
// module chunks = 0